import { ApiUrls } from '@/service/constants/urls';
import { TAddCartApiBody, TAddCartApiParams, TAddCartApiResponse } from '@/domain/Cart.domain';
import { instance } from '../Axios';
import { replaceLightframe } from '@/service/utils/replaceLightframe';

export const addCartApi = async (
    { id, partnerId }: TAddCartApiParams,
    body: TAddCartApiBody
): Promise<TAddCartApiResponse> =>
    instance
        .post(`${ApiUrls.cart.add}/${id}?partnerId=${replaceLightframe(partnerId)}`, { data: body })
        .then(({ data }) => data);
